import { EventType } from './event-type.interface';

export const GATE: EventType = {
  name: 'Gate',
  description: 'When a Gate opens or closes',
  route: 'gate',
  category: 'Security & Access',
  icon: 'gate',
  whitelist: [
    {
      proxy: 'contactsingle_gate_c4',
      events: [1, 2]
    },
    {
      proxy: 'relaycontact_electronicgate_c4',
      events: [1, 2]
    },
    {
      proxy: 'relaysingle_electronicgate_c4',
      events: [1, 2]
    },
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/gate.type.ts